var map = {
	"./boat.png": 501,
	"./boat_responsive.png": 502,
	"./bricks.png": 503,
	"./bricks_responsive.png": 504,
	"./bubbles.png": 505,
	"./bubbles_responsive.png": 506,
	"./catering.png": 507,
	"./catering_responsive.png": 508,
	"./clean_the_table.png": 509,
	"./clean_the_table_responsive.png": 510,
	"./constellations.png": 511,
	"./constellations_responsive.png": 512,
	"./demolition.png": 513,
	"./demolition_responsive.png": 514,
	"./follow_the_line.png": 515,
	"./follow_the_line_responsive.png": 516,
	"./grasp_and_place.png": 517,
	"./grasp_and_place_responsive.png": 518,
	"./hockey.png": 519,
	"./hockey_responsive.png": 520,
	"./pinball.png": 521,
	"./pinball_responsive.png": 522,
	"./roadtrip.png": 523,
	"./roadtrip_responsive.png": 524,
	"./spheroids.png": 525,
	"./spheroids_responsive.png": 526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 500;